<div class="container">
    <mat-dialog-title class="title-block">
        <h2>ADD PARTNER TO GROUP</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>

    <div class="group-container">
        <div class="group-block">
            <span id="group-label">GROUP:</span>

            <span id="group-name">
                <!-- <div *ngFor="let member of partnerGroup.members; let i = index;">
                    <span>{{ member.partner.name }}</span>
                    <span *ngIf="i < partnerGroup.members.length - 1">
                        <app-plus-icon style="padding-left: 2px; padding-right: 2px;"></app-plus-icon>
                    </span>
                </div> -->
                <span>{{ partnerGroup.name }}</span>
            </span>
        </div>
    </div>

    <mat-dialog-content class="content-block">

        <div class="content-container">

            <div class="content">
                <h5>AVAILABLE PARTNERS</h5>

                <mat-grid-list cols="1" rowHeight="2:1" class="available-partners-list">

                    <mat-grid-tile class="checkbox-field" *ngFor="let partner of availablePartners; let i = index">
                        <section class="" [ngClass]="{'selected-checkbox' : partner.selected}">
                            <mat-checkbox *ngIf="partner.partner.name != 'Mibe Music'"
                                [(ngModel)]="partner.selected"></mat-checkbox>
                            <mat-checkbox *ngIf="partner.partner.name == 'Mibe Music'"
                                [checked]="partner.partner.name == 'Mibe Music'"
                                [disabled]="partner.partner.name == 'Mibe Music'"></mat-checkbox>
                            <mat-label class="checkbox-label">{{partner.partner.name}}</mat-label>
                        </section>
                    </mat-grid-tile>

                </mat-grid-list>
            </div>

        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="add-partner-btn" mat-button (click)="addPartnersToGroup()">ADD PARTNER TO GROUP</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>